import { render, staticRenderFns } from "./ModalLoad.vue?vue&type=template&id=67907236"
import script from "./ModalLoad.vue?vue&type=script&lang=js"
export * from "./ModalLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports